import { connect } from 'react-redux';
import { RootState } from 'store/types';
import Session from './Session';
import { addSlotToProgram, removeSlotFromProgram } from 'store/Program/thunks';
import { openSessionModal } from 'store/Modal/Session/actions';
import { openInfoModal } from 'store/Modal/Info/actions';
import { registerPremiumToEvent } from 'store/Guests/thunks';
import { selectUserPremiumStatus } from 'store/Auth';

const mapStateToProps = (state: RootState) => ({
  guestProgram: state.event.guestProgram,
  eventIdsResource: state.event.eventIds,
  language: state.params.lng,
  guest: state.event.guests.items[0],
  // event: state.event.event.items[0],
  user: state.auth.user,
  search: state.slots.search,
  userPremiumStatus: selectUserPremiumStatus(state),
});

export default connect(mapStateToProps, {
  addSlotToProgram,
  removeSlotFromProgram,
  openSessionModal,
  openInfoModal,
  registerPremiumToEvent,
})(Session);
